import React, {PureComponent} from 'react';
import { withRouter } from 'react-router-dom';
import Sizeable from 'react-sizeable';
import { connect } from 'react-redux';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faFolderPlus, faFolderOpen, faCheckSquare, faChevronRight, faChevronLeft } from '@fortawesome/free-solid-svg-icons';

import Entry from '../Entry';
import Report from '../Report';
import Dialog from '../components/Dialog';

import { loadPortfolioFromHistory } from '../actions/load-portfolio.js';
import loadPortfolioHistory from '../actions/query-api/list-portfolios.js';
import loadPersonalStrategies from '../actions/query-api/personal-strategies.js';

import './style.css';

// Initialize the Font Awesome library
library.add(faFolderPlus, faFolderOpen, faCheckSquare, faChevronRight, faChevronLeft);

const Modal = ({ children }) => (
  <div className="modal"><div className="modal-inner">{children}</div></div>
);

// Split out the query params hash string into key/value pairs
function getQueryParams(hashString) {

  // Remove the app name
  const params = hashString.slice(1);

  // Get the params into key/value dict
  const queryParams = params.reduce(function (map, obj) {

    const pair = obj.split('=');
    map[pair[0]] = pair[1];
    return map;
  }, {});

  return queryParams;
}

class App extends PureComponent {

  componentWillMount() {
    this.unlisten = this.listenForUrlChanges();
  }

  componentWillUnmount() {
    this.unlisten();
  }

  listenForUrlChanges() {

    const {
      history,
      loadPortfolio,
      reloadPortfolioHistory,
      completeMyPortfolioSaving,
      dpdIsOpen,
    } = this.props;

    const unlisten = history.listen(() => {

      // Get the hash and split it by '&'
      const hash = history.location.hash.substring(1).split('&');

      // If there is only the app name then ignore
      if (hash.length === 1) {

        if (hash[0] === 'dpd' || hash[0] === 'portfolio-analysis') {          
          // Since DPD is now open set the state variable
          dpdIsOpen()
        }

        return;
      }

      // Get the query params from the rest of the hash
      const queryParams = getQueryParams(hash);

      // Check for DPD requests
      if (hash[0] === 'dpd' || hash[0] === 'portfolio-analysis') {
        
        // Since DPD is now open set the state variable
        dpdIsOpen()

        // Reload the portfolio
        if (queryParams['portfolioid']) {
          console.log('Loading portfolio ' + queryParams['portfolioid'] + ' into DPD');
          loadPortfolio(queryParams['portfolioid']);
          return;
        }

        // Check if the savedToMyPortfolios is complete
        const savedPortfolioId = queryParams['savedToMyPortfolios'];
        const newPersonalStrategyId = queryParams['newMyPortfolio'];

        if (savedPortfolioId && newPersonalStrategyId) {
          console.log('Saved portfolio ' + savedPortfolioId + ' as new My Portfolio ' + newPersonalStrategyId);
          completeMyPortfolioSaving(savedPortfolioId, newPersonalStrategyId);
          return;
        }

      }

      // Listen for PersonalStrategies links
      if (hash[0] === 'myportfolios' || hash[0] === 'my-portfolio-hub') {

        // Reload the history
        if (queryParams['reloadhistory'] && queryParams['reloadhistory'] === 'true') {
          console.log('Reloading DPD analysis history')
          reloadPortfolioHistory();
          return;
        }

      }
    });

    return unlisten;

  }

  render() {

    const {
      loading,
      analysis,
      dialog,
      onDialogSelect,
      wtDialog,
      onWtDialogClose,
      complianceText,
    } = this.props;

    // If the complianceText hasn't loaded yet we want to show the loading screen
    if (!complianceText) {
      return (
        <div className="App">
          <br />
          <h2>LOADING... PLEASE WAIT</h2>
        </div >
      )
    } else {

      return (
        <div className="App">
          {!analysis ? <Sizeable><Entry /></Sizeable> : <Sizeable><Report /></Sizeable>}

          {!loading ? null : <Modal><div className="screen-loading" /></Modal>}
          {!dialog
            ? null
            : <Modal>
              <Dialog key={dialog.message} {...dialog} onSelect={onDialogSelect} />
            </Modal>}
          {!wtDialog
            ? null
            : <div
              className="wt-dialog modal fade restricted-overlay in"
              id="externalLinkModal"
              tabIndex="-1"
              role="dialog"
              aria-labelledby="externalLinkModalLabel"
              style={{ display: "block", paddingRight: "15px" }}>
              <div className="modal-dialog" role="document">
                <div className="modal-content">
                  <div className="modal-body">
                    <button type="button" className="close" data-dismiss="modal" aria-label="Close"
                      onClick={() => onWtDialogClose()}
                    ></button>
                    <div className="form-group">
                      <h4 className="modal-title" id="externalLinkModalLabel">You are now leaving the WisdomTree Website</h4>
                    </div>
                    <div className="form-group">
                      Hyperlinks on this website are provided as a convenience and we disclaim any responsibility for information, services or products found on the websites linked hereto.
                  </div>
                    <a
                      className="continue-link secondary-link"
                      href={wtDialog}
                      target="_blanK"
                      onClick={() => onWtDialogClose()}>
                      Click here to continue</a>
                  </div>
                </div>
              </div>
            </div>}
        </div>
      );
    }
  }

}


const mapStateToProps = state => ({
  loading: state.loading,
  dialog: state.dialog,
  analysis: state.analysis,
  wtDialog: state.wtDialog,
  complianceText: state.complianceText
});

const mapDispatchToProps = dispatch => ({
  onWtDialogClose() {
    dispatch({ type: 'CLOSE_WT_DIALOG' })
  },
  onDialogSelect(callback, value) {
    dispatch({ type: 'CLOSE_DIALOG' });
    callback && callback(value);
  },
  loadPortfolio(portfolioId) {
    dispatch(loadPortfolioFromHistory(portfolioId))
  },
  reloadPortfolioHistory() {
    dispatch(loadPortfolioHistory);
    dispatch(loadPersonalStrategies);    
  },

  completeMyPortfolioSaving(portfolioId, personalStrategyId) {
    dispatch({ type: 'COMPLETED_SAVING_TO_MY_PORTFOLIOS', portfolioId: portfolioId, personalStrategyId: personalStrategyId })
  },

  dpdIsOpen() {
    dispatch({ type: 'DPD_IS_OPEN' })
  }

});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(App));



// WEBPACK FOOTER //
// ./src/App/index.js